export const ROLE_GET_REQUEST = 'ROLE_GET_REQUEST';
export const ROLE_GET_SUCCESS = 'ROLE_GET_SUCCESS';
export const ROLE_GET_ERROR = 'ROLE_GET_ERROR';
export const ROLE_GET_BY_KEY_REQUEST = 'ROLE_GET_BY_KEY_REQUEST';
export const ROLE_GET_BY_KEY_SUCCESS = 'ROLE_GET_BY_KEY_SUCCESS';
export const ROLE_GET_BY_KEY_ERROR = 'ROLE_GET_BY_KEY_ERROR';
export const ROLE_ADD_REQUEST = 'ROLE_ADD_REQUEST';
export const ROLE_ADD_SUCCESS = 'ROLE_ADD_SUCCESS';
export const ROLE_ADD_ERROR = 'ROLE_ADD_ERROR';
export const ROLE_EDIT_REQUEST = 'ROLE_EDIT_REQUEST';
export const ROLE_EDIT_SUCCESS = 'ROLE_EDIT_SUCCESS';
export const ROLE_EDIT_ERROR = 'ROLE_EDIT_ERROR';
export const ROLE_DELETE_REQUEST = 'ROLE_DELETE_REQUEST';
export const ROLE_DELETE_SUCCESS = 'ROLE_DELETE_SUCCESS';
export const ROLE_DELETE_ERROR = 'ROLE_DELETE_ERROR';
